const getters = {
    wellreport_wellName: state => state.victorysoft.wellName
}

export default getters